import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full md:w-1/2" }
const _hoisted_2 = { class: "w-full md:w-1/2" }
const _hoisted_3 = { class: "flex flex-col w-full md:flex-row md:space-x-2" }
const _hoisted_4 = { class: "relative w-full -mt-4 md:mt-0" }

import { ref, computed, type PropType, onMounted} from "vue";
import { onIonViewWillEnter } from "@ionic/vue";

import DatePicker from "@/components/inputs/DatePicker.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import { errorResponse } from "@/helpers/errorMessage";
import { BirthdayClassification } from "@/views/enums/BirthdayClassification";

interface FormInterface {
    birthdate: string|null;
    birthday_classification: number|null;
    approximate_age_month: string|null;
    approximate_age_year: string|null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBirthdateAge',
  props: {
    form: {
        type: Object,
        required: true,
    },
    errors: {
        type: Object,
        required: true,
    },
    customClass: {
        type: String,
        default: 'col-span-3',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const form = ref<FormInterface>(props.form);
const datePickerData = ref<any>(null);

const computedAge = ref<number|null>(null);

const maxDate = () => {
	return new Date();
};

const calculateAge = ():void => { 
    // Calculate the difference in milliseconds between the current date and the provided date of birth
    const diff_ms = Date.now() - (new Date(form.value.birthdate)).getTime();
    // Create a new Date object representing the difference in milliseconds and store it in the variable age_dt (age Date object)
    const age_dt = new Date(diff_ms); 
	
    // Calculate the absolute value of the difference in years between the age Date object and the year 1970 (UNIX epoch)
    computedAge.value = Math.abs(age_dt.getUTCFullYear() - 1970);
    form.value.approximate_age = computedAge.value;
}

const processBirthdate = ():void => {
	form.value.birthday_classification = BirthdayClassification.BIRTHDATE
	form.value.approximate_age_month = null;
	form.value.approximate_age_year = null;
	calculateAge();
}

const processApproximateAge = ():void => {
	form.value.birthday_classification = BirthdayClassification.APPROXIMATE_AGE
	form.value.birthdate = null;
	computedAge.value = null;
    form.value.approximate_age = null;
}

const backToDefaultAge = ():void => {
	form.value.approximate_age_year = null
	form.value.approximate_age_month = null
	computedAge.value = null;
    form.value.approximate_age = null;
}

const approxMonthMaxLength = ref(2); // Adjust this to your desired maximum length
const errorMessage = ref('');
const handleInputMonth = (event: Event) => {
    const inputEl = event.target as HTMLInputElement;
    if (inputEl.value.length > approxMonthMaxLength.value) {
        form.value.approximate_age_month = inputEl.value.slice(0, approxMonthMaxLength.value);
    }

    errorMessage.value = validateNumber(form.value.approximate_age_month);
};

const validateNumber = (value: string): string => {
    const parsedValue = parseInt(value, 10);
    if ( parsedValue < 0 || parsedValue > 12) {
        form.value.approximate_age_month = ''
        return 'Invalid input: Must be a number between 0 - 12.';
    }

    return ''; // Clear error message if valid
};

const approxYearMaxLength = ref(4); // Adjust this to your desired maximum length
const errorMessageYear = ref('')
const handleInputYear = (event: Event) => {
    const inputEl = event.target as HTMLInputElement;
    
    if (inputEl.value.length > approxYearMaxLength.value) {
        form.value.approximate_age_year = inputEl.value.slice(0, approxYearMaxLength.value);
    }

    if (inputEl.value.includes('.')) {
        errorMessageYear.value = 'Invalid input: Must be a whole number.';
        form.value.approximate_age_year = ''
    }
};

const disabledApproximateAge= computed<boolean>(():boolean => {
	if(form.value.birthdate){
		processBirthdate()
		return true;
	} else if ( 
        (form.value.approximate_age_month === "" && form.value.approximate_age_year === "") ||
        (form.value.approximate_age_month == null && form.value.approximate_age_year == null)
    ) { 
		backToDefaultAge()
		return false;
	}

	return false;
})

const disabledBirthday = computed<boolean>(():boolean => {
	if(
        (form.value.approximate_age_month === "" && form.value.approximate_age_year === "") ||
        (form.value.approximate_age_month == null && form.value.approximate_age_year == null)
    ) { 
		backToDefaultAge()
		return false;
	} else {
		processApproximateAge()
		return true;
	}
})

const clearForm = ():void => {
    // console.log(form.value);
    // form.value.birthdate = null;
    // form.value.approximate_age_year = null;
    // form.value.approximate_age_month = null;
}

__expose({
    datePickerData
})

onIonViewWillEnter(async () => {
    clearForm()
});

onMounted(async () => {
    clearForm()
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col space-y-3 md:flex-row md:space-x-2 md:space-y-0", __props.customClass]),
      id: "birthday_classification"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DatePicker, {
          ref_key: "datePickerData",
          ref: datePickerData,
          id: "birthdate",
          name: "birthdate",
          label: "Birthdate",
          modelValue: form.value.birthdate,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((form.value.birthdate) = $event)),
            _cache[1] || (_cache[1] = value => (form.value.birthdate = value))
          ],
          error: __props.errors?.birthdate,
          disabled: disabledBirthday.value || __props.disabled,
          maxDate: maxDate
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          type: "number",
          label: "Age",
          placeholder: "Age",
          name: "approximate_age",
          id: "approximate_age",
          modelValue: computedAge.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((computedAge).value = $event)),
          disabled: true
        }, null, 8, ["modelValue"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(__props.customClass)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          type: "number",
          label: "Approximate Age",
          placeholder: "Years",
          name: "approximate_age",
          id: "approximate_age",
          modelValue: form.value.approximate_age_year,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.approximate_age_year) = $event)),
          error: __props.errors?.approximate_age_year || errorMessageYear.value,
          onInput: handleInputYear,
          disabled: disabledApproximateAge.value || __props.disabled
        }, null, 8, ["modelValue", "error", "disabled"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextInput, {
            type: "number",
            label: "‎",
            placeholder: "Months",
            onInput: handleInputMonth,
            name: "approximate_age_months",
            id: "approximate_age_months",
            modelValue: form.value.approximate_age_month,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.approximate_age_month) = $event)),
            error: __props.errors?.approximate_age_month || errorMessage.value ,
            disabled: disabledApproximateAge.value || __props.disabled
          }, null, 8, ["modelValue", "error", "disabled"])
        ])
      ])
    ], 2)
  ], 64))
}
}

})